import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { omit } from 'lodash'
import { getGeoParams } from 'utils/parameters'
import { flattenLocations } from 'utils/geo'
import { actionCreators as geoPickerActionCreators } from 'reduxBits/geoPicker'
import TopInfoLink from '../TopInfoLink'

export const getAdLocationBelowQueryLocation = (adLocation, { r, ag, co, m }) => {
  const lastIndex = adLocation.length - 1
  let locationIndex

  // If we don't have a region or we have "angränsande län" selected,
  // take the topmost location
  if (!r || ag === '1' || co) {
    locationIndex = 0
  } else if (m) {
    // if we have a municipality selected, take the last location
    locationIndex = lastIndex
  } else {
    locationIndex = Math.min(lastIndex, 1)
  }

  return adLocation[locationIndex]
}

const Region = ({ query = {}, location, setGeoPreference, byQueryKey, isShippingEnabled }) => {
  // always show region instead of municipality or subarea if it's a shipping ad
  const subLocation = isShippingEnabled
    ? location[0]
    : getAdLocationBelowQueryLocation(location, query)
  const allRegions = flattenLocations(byQueryKey.r)
  const matchedRegions = allRegions.filter((region) => region.label === subLocation.name)
  const requiredRegion =
    matchedRegions && matchedRegions.length > 0 && matchedRegions[matchedRegions.length - 1]
  let regionLocation = {}
  if (subLocation.queryKey === 'co') {
    // select query in utland
    regionLocation = { [subLocation.queryKey]: subLocation.id, cg: '3080' }
  } else regionLocation = requiredRegion && getGeoParams(requiredRegion.value)

  let newQuery
  if (subLocation && subLocation.queryKey && subLocation.id) {
    newQuery = {
      ...omit(query, 'page', 'ag'),
      ...regionLocation,
    }
  }

  const onClick = () => {
    // to update the redux state and cookie
    setGeoPreference(newQuery)
  }

  return (
    <TopInfoLink onClick={onClick} newQuery={newQuery}>
      {subLocation.name}
    </TopInfoLink>
  )
}

Region.propTypes = {
  query: PropTypes.object,
  location: PropTypes.array.isRequired,
  setGeoPreference: PropTypes.func.isRequired,
  byQueryKey: PropTypes.object.isRequired,
  isShippingEnabled: PropTypes.bool,
}

const mapStateToProps = (state) => ({
  byQueryKey: state.searchParams.byQueryKey,
})

const mapDispatchToProps = (dispatch) => ({
  setGeoPreference: (query) => dispatch(geoPickerActionCreators.setGeoPreference(query)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Region)
